import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SharedModule } from '../../utils/shared.module';
import { I18ns } from '../../utils/i18n/I18n';
import { ApiService } from '../../data/api.service';
import { StoreService } from '../../data/store.service';
import { ThemesComponent } from '../themes/themes.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [SharedModule, RouterLink, ThemesComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  I18ns = I18ns;

  constructor(
    private readonly api: ApiService,
    private readonly store: StoreService,
  ) {}
}
